// Multi-promo free gift engine
// Expects window.freeGiftPromos = [
//   { id, thresholdCents, giftVariantId, eligibleProductIds: [productIds...] },
//   ...
// ]

window.syncFreeGiftWithCart = function () {
  // Safety: only run for US if localization is available
  if (
    window.localization &&
    window.localization.country &&
    window.localization.country.iso_code !== 'US'
  ) {
    return Promise.resolve(null);
  }

  const promos = Array.isArray(window.freeGiftPromos) ? window.freeGiftPromos : [];
  if (!promos.length) {
    // No promos configured → nothing to do
    return Promise.resolve(null);
  }

  // 1) Read current cart once
  return fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      let currentState = cart; // will be updated as we add/remove gifts
      let lastState = null; // remember last response with sections

      function processPromo(index) {
        if (index >= promos.length) {
          // Done processing all promos
          return Promise.resolve(lastState);
        }

        const promo = promos[index];
        const eligibleIds = (promo.eligibleProductIds || []).map(Number);
        const thresholdCents = Number(promo.thresholdCents || 0);
        const giftVariantId = Number(promo.giftVariantId);

        const items = currentState.items || cart.items || [];
        const subtotalCents =
          typeof currentState.items_subtotal_price === 'number'
            ? currentState.items_subtotal_price
            : cart.items_subtotal_price || 0;

        // Does the cart contain at least one eligible product for this promo?
        const hasEligibleProduct = eligibleIds.length
          ? items.some((item) => eligibleIds.includes(item.product_id))
          : true;

        const giftIndex = items.findIndex((item) => item.variant_id === giftVariantId);
        const hasGift = giftIndex !== -1;

        let action = null;
        let lineNumber = null;

        // RULES per promo:
        // 1) No eligible products → remove gift if present
        if (!hasEligibleProduct && hasGift) {
          action = 'remove';
          lineNumber = giftIndex + 1;
        }
        // 2) Eligible products + subtotal >= threshold → ensure gift present
        else if (hasEligibleProduct && subtotalCents >= thresholdCents && !hasGift) {
          action = 'add';
        }
        // 3) Eligible products but subtotal < threshold → remove gift if present
        else if (hasEligibleProduct && subtotalCents < thresholdCents && hasGift) {
          action = 'remove';
          lineNumber = giftIndex + 1;
        }

        // No change needed for this promo → process the next one
        if (!action) {
          return processPromo(index + 1);
        }

        // Perform required action, then recurse
        if (action === 'add') {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: giftVariantId,
              quantity: 1,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          })
            .then((res) => res.json())
            .then((state) => {
              currentState = state;
              lastState = state;
              return processPromo(index + 1);
            });
        } else {
          // remove
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line: lineNumber,
              quantity: 0,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          })
            .then((res) => res.json())
            .then((state) => {
              currentState = state;
              lastState = state;
              return processPromo(index + 1);
            });
        }
      }

      // Kick off the chain
      return processPromo(0);
    });
};
